module.exports = __webpack_public_path__ + "assets/4e3b7ad249b6093dc3881675d0df2a53.mp3";